import React, { useContext, useEffect } from 'react';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';
import GlobalStyled from './../../AcessoExlusivo.style';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import Loading from 'components/Loading';
import OverviewExclusivo from '../components/OverviewExclusivo';
import CicloExclusivo from '../components/CicloExclusivo';
import aceleraLogo from './../../../../images/solutions/logo/aceleraBrasilLogo.png';
import MateriaisExclusivos from '../components/MateriasExclusivos';
import { ListMateriaisAceleraPlanoAnual } from './ListMateriaisAcelera';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import UsuarioDTO from 'models/UsuarioDTO';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import SessionFerramentaVideo from 'pages/acessoExclusivo/components/SessionFerramentaVideo';

const AceleraPrivate = () => {
    const { loading, idsMyCategorias } = useContext(AcessoExclusivoContext.Context);
    const isMobile = IsMobileBiggerWidth();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);
    const isApoioCultura = idsMyCategorias.some(id => id === 35) && !usuarioLogado.email.includes('@ias');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <GlobalStyled.GlobalContainer isMobile={isMobile}>
            {loading ? (
                <>
                    <Loading />
                </>
            ) : (
                <>
                    <OverviewExclusivo
                        isBlue
                        mencao={
                            [2, 3, 4, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Ministério da Cultura apresenta o projeto Plano Anual Instituto Ayrton Senna.'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Ministério da Cultura apresenta o projeto Apoio Cultural e Educacional para Escolas das Redes Públicas Estadual e Municipal do Instituto Ayrton Senna.'
                                : ''
                        }
                        title="Acelera Brasil"
                        img="ExclusivoAceleraImagem1.JPG"
                        logo={aceleraLogo}
                        arquivo={'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Visão Geral_Acelera.pdf'}
                        nome_arquivo="Acelera_Visao_Geral"
                        description={`
                           O <b>Acelera Brasil</b> é uma proposta que tem como objetivo corrigir ou reduzir a distorção idade-ano, por meio da aceleração do fluxo escolar de estudantes, prioritariamente entre o 3º e o 5º ano do Ensino Fundamental. 
                            </br></br>
                            A coleção foi construída com base nas diretrizes curriculares nacionais e contempla os conteúdos essenciais até o 5º ano, garantindo que os alunos avancem de forma segura, com aprendizagem efetiva e acompanhamento contínuo ao longo do processo. 
                            </br></br>
                            Acesse o documento de visão geral para saber mais.
                        `}
                        regua={
                            [2, 3, 4, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Reguas_Logo/2026_Regua_Plano_Anual_Defeso_Eleitoral_pequena.jpg'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Reguas_Logo/2026_Regua_Roanet_Disseminacao_Hor_apoio_comprimida.jpg'
                                : ''
                        }
                        isButtonHidden={idsMyCategorias.some(() => idsMyCategorias.includes(1)) ? true : false}
                    />

                    <CicloExclusivo
                        title="Curso Acelera Brasil"
                        description={`
                         O curso <b>Acelera Brasil</b> foi desenvolvido para apoiar professores, coordenadores pedagógicos, diretores e técnicos das redes públicas de ensino na implementação da proposta. 
                        </br></br>
                        Ao longo da formação, você vai conhecer em profundidade os conteúdos da solução educacional e se apropriar dos materiais e práticas essenciais para acelerar o percurso dos estudantes 
                        com qualidade e cuidado. 
                        </br></br>
                        <b>Vamos juntos?</b></br>
                        Inicie agora o curso e fortaleça sua atuação com ainda mais intencionalidade. 
                        `}
                        img="ExclusivoAceleraImagem2.jpg"
                        itens={[
                            {
                                title: 'Curso Acelera Brasil',
                                url: isApoioCultura
                                    ? '/cursos/acelera_brasil/acelera_brasil_apoio_cultural'
                                    : '/cursos/acelera_brasil/acelera_brasil?redirect=exclusivo/acelera-brasil',
                                isBlock: false,
                                titleIsBlock: `Esse curso não está disponível.`,
                            },
                        ]}
                    />
                    <MateriaisExclusivos
                        title="Materiais especiais para download"
                        description={`<p>Acesse os materiais exclusivos do <b>Acelera Brasil</b> e conheça mais de perto a proposta. Eles foram pensados para apoiar sua prática e facilitar a implementação da solução na rede.</p>
                            <p>Os materiais de Matemática que são disponibilizados nesta página não contam com incentivo da Lei Rouanet. Todos foram produzidos exclusivamente pelo Instituto Ayrton Senna.</p> `}
                        img={'anexo_storage_files_10384181528135196819.jpg_2025-03-27-1743101602256.jpg'}
                        items={ListMateriaisAceleraPlanoAnual}
                    />
                    <SessionFerramentaVideo solucaoId={4} />
                    <ContactContainer />
                </>
            )}
        </GlobalStyled.GlobalContainer>
    );
};

export default AceleraPrivate;
